import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import MindYourNature from './pages/MindYourNature';
import YinKlangNature from './pages/YinKlangNature';
import Horizon from './pages/Horizon';
import EventInfo from './pages/EventInfo';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mind-your-nature" element={<MindYourNature />} />
        <Route path="/yin-klang-nature" element={<YinKlangNature />} />
        <Route path="/horizon-5" element={<Horizon />} />
        <Route path="/event" element={<EventInfo />} />
      </Routes>
    </Router>
  );
}

export default App;